import React from 'react'
import Carousel from '../../components/Carousel'
import TestimonialCard from '../../components/TestimonialCard'
import TestimonialGroup from '../../models/FeedbackModel'
interface Props {
	testimonials: TestimonialGroup[],
}

const TestimonialContainer: React.FC<Props> = ({ testimonials = [] }) => {
	return (
		<Carousel
			style={{ height: '271px', marginBottom: '87px' }}
			perPage={1} buttonOut>
			{testimonials.map((testimonial, id) => (
				<TestimonialCard
					title={testimonial.title}
					subtitle={testimonial.subtitle}
					image={testimonial.image}
					text={testimonial.text}
					key={id}
				/>
			))}
		</Carousel>
	)
}

export default TestimonialContainer